import { useEffect, useState } from "react";
import { API } from "./products";

// Cached fetch of admin-managed homepage media overrides ({ key: url }).
let cache = null;
let inflight = null;

function fetchMedia() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch(`${API}/site/media`)
      .then((r) => r.json())
      .then((d) => {
        cache = d && typeof d === "object" ? d : {};
        return cache;
      })
      .catch(() => {
        cache = {};
        return cache;
      });
  }
  return inflight;
}

export function useSiteMedia() {
  const [media, setMedia] = useState(cache || {});
  useEffect(() => {
    let active = true;
    fetchMedia().then((d) => {
      if (active) setMedia(d);
    });
    return () => {
      active = false;
    };
  }, []);
  return media;
}
